import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { MembersBlob } from '../members/MemberWithRegistrationsBlob';
import { Payment } from '../members/Payment';
import { RegistrationWithMember } from '../members/RegistrationWithMember';
export class RegisterResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.payment = null;
        this.paymentUrl = null;
        this.registrations = [];
    }
}
__decorate([
    field({ decoder: Payment, nullable: true })
], RegisterResponse.prototype, "payment", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 28 })
], RegisterResponse.prototype, "paymentUrl", void 0);
__decorate([
    field({ decoder: MembersBlob })
], RegisterResponse.prototype, "members", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(RegistrationWithMember), version: 19 })
], RegisterResponse.prototype, "registrations", void 0);
//# sourceMappingURL=RegisterResponse.js.map